import React__default, { forwardRef } from 'react';
import styled from 'styled-components';
import { themeGet } from '../../utils/theme-get.js';
import Box from '../Box/Box.js';
import { useRefObjectAsForwardedRef } from '../../hooks/useRefObjectAsForwardedRef.js';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const StyledArrow = styled(Box).withConfig({
  displayName: "RuleStepLabel__StyledArrow",
  componentId: "sc-jwxwjc-0"
})(["position:absolute;background-color:", ";height:100%;&[data-placement='left']{clip-path:polygon(0 50%,10% 100%,40% 100%,60% 100%,90% 100%,100% 50%,90% 0,60% 0,40% 0,10% 0);transform:rotateY(180deg);left:-8px;width:100%;}&[data-placement='right'][data-condition='if']{clip-path:polygon(0 50%,10% 100%,40% 100%,60% 100%,90% 100%,100% 50%,90% 0,60% 0,40% 0,10% 0);right:-8px;width:100%;}&[data-placement='right'][data-condition='then']{clip-path:polygon(0% 0%,100% 50%,0% 100%);transform:rotate(0deg);right:-9px;width:10px;height:100%;}"], ({
  isSelected
}) => isSelected ? themeGet('colors.background.selected.bold.default') : themeGet('colors.background.neutral.bold.default'));
const StyledStepLabel = styled(Box).withConfig({
  displayName: "RuleStepLabel__StyledStepLabel",
  componentId: "sc-jwxwjc-1"
})(["display:flex;align-items:center;justify-content:center;position:relative;padding:", " ", ";background-color:", ";color:", ";font-weight:", ";font-size:", ";text-transform:uppercase;border-radius:", ";user-select:none;&:hover{background-color:", ";}& > span{z-index:1;}"], themeGet('space.1'), themeGet('space.2'), ({
  isSelected
}) => isSelected ? themeGet('colors.background.selected.bold.default') : themeGet('colors.background.neutral.bold.default'), themeGet('colors.text.inverse'), themeGet('fontWeights.semibold'), themeGet('fontSizes.2'), ({
  condition
}) => condition === 'when' ? themeGet('radii.1') : '', ({
  isSelected
}) => isSelected ? themeGet('colors.background.selected.bold.hovered') : themeGet('colors.background.neutral.bold.hovered'));
const StyledStepLabelWrapper = styled(Box).withConfig({
  displayName: "RuleStepLabel__StyledStepLabelWrapper",
  componentId: "sc-jwxwjc-2"
})(["display:flex;position:relative;&:hover ", "{background-color:", ";}&:hover ", "{background-color:", ";}"], StyledArrow, ({
  isSelected
}) => isSelected ? themeGet('colors.background.selected.bold.hovered') : themeGet('colors.background.neutral.bold.hovered'), StyledStepLabel, ({
  isSelected
}) => isSelected ? themeGet('colors.background.selected.bold.hovered') : themeGet('colors.background.neutral.bold.hovered'));
const RuleStepLabelArrow = ({
  placement,
  condition,
  isSelected,
  ...props
}) => {
  return /*#__PURE__*/React__default.createElement(StyledArrow, _extends({
    "data-placement": placement,
    isSelected: isSelected,
    "data-condition": condition
  }, props));
};
RuleStepLabelArrow.displayName = "RuleStepLabelArrow";
const RuleStepLabel = /*#__PURE__*/forwardRef(({
  label,
  description,
  condition,
  children,
  isSelected: isSelectedProp,
  isCompletedStep,
  testId,
  ...props
}, forwardedRef) => {
  const containerRef = React__default.useRef(null);
  useRefObjectAsForwardedRef(forwardedRef, containerRef);
  const labelTestId = `${testId}-step-label`;
  const isActive = isSelectedProp || isCompletedStep;
  const shouldRender = !!label || !!description;
  return shouldRender ? /*#__PURE__*/React__default.createElement(StyledStepLabelWrapper, {
    ref: containerRef,
    sx: {
      display: 'flex',
      position: 'relative',
      width: 'fit-content'
    },
    "data-testid": testId ? labelTestId : undefined,
    isSelected: isActive
  }, condition === 'if' ? /*#__PURE__*/React__default.createElement(RuleStepLabelArrow, {
    condition: condition,
    placement: "left",
    isSelected: isActive
  }) : null, /*#__PURE__*/React__default.createElement(StyledStepLabel, {
    isSelected: isActive,
    label: label,
    condition: condition,
    "data-testid": testId ? labelTestId : undefined
  }, /*#__PURE__*/React__default.createElement("span", null, label)), condition === 'if' ? /*#__PURE__*/React__default.createElement(RuleStepLabelArrow, {
    isSelected: isActive,
    condition: "if",
    placement: "right"
  }) : null, condition === 'then' ? /*#__PURE__*/React__default.createElement(RuleStepLabelArrow, {
    isSelected: isActive,
    condition: "then",
    placement: "right"
  }) : null) : null;
});
RuleStepLabel.displayName = 'RuleStepLabel';
var RuleStepLabel$1 = RuleStepLabel;

export { RuleStepLabel$1 as default };
